import startOfDay from 'date-fns/startOfDay'
import subtractUtcOffset from 'utils/subtractUtcOffset'

export default function startOfDayUtc(date: Date) {
  return startOfDay(subtractUtcOffset(date))
}
